import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPayslipConfigLog,
// 获取工资条安全配置修改记录
payslipConfigInit // 工资条安全配置枚举项
} from '@/api/payroll/pay-slip';
import Pagination from '_c/pagination';
// 员工搜索组件
import StaffSearch from '_c/staff-search';
export default {
  components: {
    Pagination: Pagination,
    StaffSearch: StaffSearch
  },
  data: function data() {
    return {
      operationTime: [],
      options: [],
      formData: {
        operate_id: '',
        column: '',
        start_time: '',
        end_time: '',
        total: 0,
        page: 1,
        page_size: 20
      },
      tableData: []
    };
  },
  created: function created() {
    var _this = this;
    this.getList(1);
    payslipConfigInit().then(function (_ref) {
      var data = _ref.data;
      _this.options = data.column;
    });
  },
  methods: {
    handlerBack: function handlerBack() {
      this.$router.push('/payroll/safe-pay-slip');
    },
    getList: function getList(page) {
      var _this2 = this;
      this.formData.page = page;
      getPayslipConfigLog(this.formData).then(function (_ref2) {
        var data = _ref2.data;
        _this2.tableData = data.list;
        _this2.formData.total = data.total;
      });
    },
    handlerTime: function handlerTime(val) {
      ;
      var _ref3 = val || ['', ''];
      var _ref4 = _slicedToArray(_ref3, 2);
      this.formData.start_time = _ref4[0];
      this.formData.end_time = _ref4[1];
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.page_size = val;
      this.getList(1);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.getList(val);
    }
  }
};